<template>
  <div class="">
    <div class="x-banner">
      <BANNER></BANNER>
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>

    <div class="container-width mt50">
      <div class="x-title">院标/办院理念/院训/院歌</div>
      <div class="yuanbiao">
        <div class="y-item">
          <a href="/sjwh/yuange" title="院标">
            <img src="@/assets/image/yuanbiao.png" />
          </a>
        </div>
        <div class="y-item" title="院训">
          <a href="/sjwh/yuange">
            <img src="@/assets/image/yuanxun.png" />
          </a>
        </div>
        <div class="y-item" title="院歌">
          <a href="/sjwh/yuange">
            <img src="@/assets/image/yuange.jpg" />
          </a>
        </div>
      </div>
    </div>

    <div class="mt50 tv">
      <div class="container-width">
        <ul class="tv-title">
          <li class="video-li on">
            <a class="">盛京TV</a>
          </li>
        </ul>
        <ul class="tv-list">
          <div class="flv">
            <video
              controls="controls"
              width="1127"
              height="632"
              id="videoElement"
              :poster="tvContent.img"
            ></video>
          </div>
          <div class="title">{{ tvContent.title }}</div>
        </ul>
      </div>
    </div>

    <div class="container-width mt50">
      <div class="x-title">图片盛京</div>
    </div>
    <section class="media-block">
      <div class="container-width">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              style="width: 310px; margin-right: 30px"
              v-for="(item, index) in imgListData"
              :key="index"
              @click="goArticle(item.id)"
            >
              <div class="img">
                <img :src="item.img" />
              </div>
              <p>{{ item.title }}</p>
            </div>
          </div>
          <div
            class="swiper-button-prev"
            tabindex="0"
            role="button"
            aria-label="Previous slide"
            aria-disabled="false"
          ></div>
          <div
            class="swiper-button-next"
            tabindex="0"
            role="button"
            aria-label="Next slide"
            aria-disabled="false"
          ></div>
          <span
            class="swiper-notification"
            aria-live="assertive"
            aria-atomic="true"
          ></span>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import service from "../../service/sjwh";
import BANNER from "../../components/banner/sjwh";
import config from "../../config/dev";
import flvjs from "flv.js";
export default {
  name: "SJWH",
  data() {
    return {
      navigationData: [
        {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        // {
        //   name: "盛京医讯",
        //   path: "/sjwh/zhoukan",
        //   width: "33%",
        // },
        // {
        //   name: "盛京TV",
        //   path: "/sjwh/tv",
        // },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
      currentPath: "/sjwh",
      imgListData: [],
      hundredYearsData: {
        img: "",
      },
      thirtyYearsData: {
        img: "",
      },
      showData: false,
      themeSong: {}, // 院歌
      hospitalTraining: {}, // 院标
      academy: {}, // 院训
      tvContent: {
        title: "",
        video: "", // 视频地址
        url: "", // 下载地址
      },
      yingxiangContent: {
        title: "",
        video: "", // 视频地址
        url: "", // 下载地址
      },
      gushiContent: {
        title: "",
        video: "", // 视频地址
        url: "", // 下载地址
      },
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      // 图片盛京
      let parmes = {
        isShow: "1",
      };
      service.getHisList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          });

          this.imgListData = res.content;
          this.showData = true;
          this.$nextTick(() => {
            this.swiperImg();
          });
        }
      });
      // 大道精深 大道精诚
      service.getMainRoad({}, (res) => {
        res.img = res.img
          ? config.url + "/file/downloadFile/" + res.img + "?isDownload=true"
          : "";
        this.hundredYearsData = { ...res };
      });
      //奉天三十年
      service.getThirtyYears({}, (res) => {
        if (res.img) {
          res.img =
            config.url + "/file/downloadFile/" + res.img + "?isDownload=true";
        }
        if (res.fujianids) {
          res.fujianids =
            config.url +
            "/file/downloadFile/" +
            res.fujianids +
            "?isDownload=true";
        }

        this.thirtyYearsData = { ...res };
      });
      let tvparmes = {
        pageIndex: 1,
        pageSize: 1,
        isshow: 1,
      };
      service.getwzTvList(tvparmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            // 处理下载地址 和 视频地址
            if (item.url) {
              item.video = item.url;
            } else {
              item.video = config.url + "/file/getVideo?id=" + item.video;
            }
          });
        }
        this.tvContent = { ...res.content[0] };
        this.videoInit(res.content[0].video);
      });
      // service.getSjImageList(parmes, (res) => {
      //   if (res.content.length) {
      //     res.content.map((item) => {
      //       // 处理下载地址 和 视频地址
      //       if (item.url) {
      //         item.video = item.url;
      //       } else {
      //         // 视频地址
      //         item.video = config.url + "/file/getVideo?id=" + item.video;
      //       }
      //     });
      //   }
      //   this.yingxiangContent = { ...res.content[0] };
      //   this.videoInit();
      // });
      // service.getSjStoryList(parmes, (res) => {
      //   if (res.content.length) {
      //     res.content.map((item) => {
      //       // 处理下载地址 和 视频地址
      //       if (item.url) {
      //         item.video = item.url;
      //       } else {
      //         // 视频地址
      //         item.video = config.url + "/file/getVideo?id=" + item.video;
      //       }
      //     });
      //   }
      //   this.gushiContent = { ...res.content[0] };
      //   this.videoInit();
      // });
    },
    play() {
      this.flvPlayer.play();
    },

    // 图集
    goArticle(id) {
      this.$router.push({
        path: `/sjwh/article`,
        query: {
          atlas: id,
        },
      });
    },
    // 视频初始化
    videoInit(url) {
      if (flvjs.isSupported()) {
        var videoElement = document.getElementById("videoElement");
        this.flvPlayer = flvjs.createPlayer(
          {
            type: "flv",
            isLive: true,
            hasAudio: true, // 是否有音频
            hasVideo: true, // 是否有视频
            url: url,
            enableStashBuffer: true, //是否启用缓存区
          },
          {
            enableWorker: false, //不启用分离线程
            enableStashBuffer: false, //关闭IO隐藏缓冲区
            autoCleanupSourceBuffer: true, //自动清除缓存
            lazyLoad: false,
          }
        );
        this.flvPlayer.attachMediaElement(videoElement);
        this.flvPlayer.load();
      }
    },
    handlehundred() {
      this.$router.push({
        path: `/sjwh/article/hundred`,
      });
    },
    swiperImg() {
      var swiper = new Swiper(".swiper-container", {
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: {
          delay: 1000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
  },
  mounted() {},
  watch: {},
  destroyed() {},
};
</script>

<style scoped lang="scss">
.tv {
  background: url(../../assets/v-bg.png);
  background-size: 100% 100%;
  padding: 50px;
  .container-width {
    padding: 150px 0 150px 0;
    box-sizing: border-box;
  }
}
.tv-title {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;

  li {
    margin-right: 30px;
    a {
      height: 60px;
      text-align: center;
      position: relative;
      font-size: 32px;
      line-height: 50px;
      color: #333;
    }
  }
  .on {
    a {
      color: #00479d;
    }
  }
}
.tv-list {
  margin: 50px auto 0;

  .flv {
    width: 1127px;
    height: 632.5px;
    -webkit-box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
    margin: 0 auto;
    background: #fff;
  }
  .title {
    margin: 20px auto;
    text-align: center;
    font-size: 24px;
  }
}
.hundred {
  p {
    margin-top: 30px;
    font-size: 1.2rem;
    line-height: 40px;
  }
}


.yuanbiao {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-row-gap: 30px;
  grid-column-gap: 30px;
  margin-top: 30px;
  .y-item {
    background: #fff;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;

    -webkit-box-align: center;
    align-items: center;
    height: 285px;
    overflow: hidden;
    box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
    cursor: pointer;
    padding: 10px 20px;
    box-sizing: border-box;
    a {
      max-width: 90%;
      max-height: 90%;
      img {
        max-width: 100%;
        max-height: 230px;
      }
    }
  }
}
.swiper-slide {
  border: 1px solid #ebebeb;
  border-radius: 5px;
  position: relative;
  p {
    position: absolute;
    bottom: 0px;
    background: rgba(6, 6, 6, 0.5);
    height: 50px;
    color: #fff;
    font-size: 1rem;
    padding: 10px 20px;
    box-sizing: border-box;
    width: 100%;
  }
}
</style>
